
<section class="nach-wrap">
  <div class="wrap-lg">
    <div class="nach-inner">
      <!-- <div class="nav-sec" (click)="util.route('home')">
        <div class="back-nav">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Please Complete the NACH Mandate</div>
          <div class="page-info">Please select the mode of payment by which you would like to pay.</div>
        </div>
      </div> -->
      <!-- Scenario 1 -->
      <div *ngIf="!pNach && !this.mandateVariants.eNachOption" class="box-wrap">
        <div class="nach-list">
          <div class="nach-item" *ngFor="let applicant of loanApplicants;">
            <div class="left">
              <div class="name">{{applicant.applicantName | titlecase}}</div>
              <div class="role">{{applicant.mainApplicant ? 'Applicant':'Co-applicant'}}</div>
            </div>
            <div class="right">
              <div class="bank-item {{bank.isSelected? 'active':''}}" (click)="selectBank(bank)" *ngFor="let bank of (applicant.loanBankConnectAccountsInfo || [])">
                <div class="option-dot"></div>
                <div class="data-pair">
                  <div class="label">Bank </div>
                  <div class="value">{{bank.bankName}}</div>
                </div>
                <div class="data-pair">
                  <div class="label">Account Number</div>
                  <div class="value">********{{(bank.accountNo + '').substr(-4)}}</div>
                </div>
                <div class="data-pair">
                  <div class="label">Branch </div>
                  <div class="value">{{getBranchName(bank).branch | titlecase}}</div>
                </div>
                <div class="data-pair">
                  <div class="label">IFSC Code</div>
                  <div class="value">{{bank.ifsc}}</div>
                </div>
              </div>
              <!-- <div class="bank-item">
                <div class="option-dot"></div>
                <div class="data-pair">
                  <div class="label">Bank </div>
                  <div class="value">Bank of baroda</div>
                </div>
                <div class="data-pair">
                  <div class="label">Account Number</div>
                  <div class="value">********0345</div>
                </div>
                <div class="data-pair">
                  <div class="label">Branch </div>
                  <div class="value">Bangalore</div>
                </div>
                <div class="data-pair">
                  <div class="label">IFSC Code</div>
                  <div class="value">BKPA0008225</div>
                </div>
              </div>
              <div class="bank-item">
                <div class="option-dot"></div>
                <div class="data-pair">
                  <div class="label">Bank </div>
                  <div class="value">Bank of baroda</div>
                </div>
                <div class="data-pair">
                  <div class="label">Account Number</div>
                  <div class="value">********0345</div>
                </div>
                <div class="data-pair">
                  <div class="label">Branch </div>
                  <div class="value">Bangalore</div>
                </div>
                <div class="data-pair">
                  <div class="label">IFSC Code</div>
                  <div class="value">BKPA0008225</div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="page-action">
          <button class="btn-primary" [disabled]="!selectedbank || !disbursementDate" (click)="submit()">Continue</button>
        </div>
      </div>

      <!-- Scenario 2 -->
      <div *ngIf="!pNach && this.mandateVariants.eNachOption" class="box-wrap with-head">
        <div class="box-header">
          Select an option
        </div>
        <div class="box-content">
          <div class="nach-radio">
            <div class="cus-check round" *ngIf="nachMandateData.isDebitCard || nachMandateData.isNetBanking">
              <input class="input-check" type="radio" id="e_nach_mandate" name="nach_selection" value="emandate" [(ngModel)]="mandateOptionValue"/>
              <label for="e_nach_mandate">e-NACH Mandate</label>
            </div>
            <div class="cus-check round" *ngIf="nachMandateData.isEsign">
              <input class="input-check" type="radio" id="aadhar_mandate" name="nach_selection" value="esign" [(ngModel)]="mandateOptionValue"/>
              <label for="aadhar_mandate">Aadhaar Mandate <span class="recommend-tag" *ngIf="nachMandateData.emandateRejectCount>=3 && !isAadhaarMandateFailed">Recommended</span></label>
            </div>
            <div class="cus-check round" *ngIf="nachMandateData.isPhysicalNach">
              <input class="input-check" type="radio" id="p_nach_mandate" name="nach_selection" value="isPhysicalNach" [(ngModel)]="mandateOptionValue"/>
              <label for="p_nach_mandate">p-NACH Mandate <span class="recommend-tag" *ngIf="isAadhaarMandateFailed">Recommended</span></label>
            </div>
          </div>
          <div class="page-action" [class.with-info]="((nachMandateData.emandateRejectCount>=3 && !isAadhaarMandateFailed) || isAadhaarMandateFailed) && util.isMobile">
            <div class="act-info" *ngIf="nachMandateData.emandateRejectCount>=3 && !isAadhaarMandateFailed" [innerHTML]="nachRECOMMENDATION.message2.replace('Aadhaar Mandate', '<strong>Aadhaar Mandate</strong>')"></div>
            <div class="act-info" *ngIf="isAadhaarMandateFailed" >Your mandate registration was unsuccessful, We recommend you to try <strong>p-NACH Mandate</strong> option. </div>
            <button class="btn-primary" (click)="submitMandate()">Continue</button>
          </div>
        </div>
      </div>

      <!-- Scenario 3 -->
      <app-p-nach *ngIf="pNach" [isPnachformDownloaded]="nachMandateData.isPnachformDownloaded" [selectedBanks]="selectedbank" [nachData]="nachData"></app-p-nach>
    </div>
  </div>
</section>

<!-- NACH Verify -->
<p-dialog [(visible)]="mandatePopup" [modal]="true" styleClass="cus-dialog-sm cus-dialog nach-dialog" [draggable]="false" [resizable]="false">
  <div class="nach-content">
    <div class="gradient-line"></div>
    <div class="nach-left">
      <img src="assets/images/dialog/mandate_info.svg" alt="Loader Image" />
    </div>
    <!-- For E-Mandate -->
    <div class="nach-right" *ngIf="mandateVariants.emandate">
      <div class="nach-title">We are initiating your <span class="wrap-text">E-mandate registration</span></div>
      <div class="nach-info">Kindly make sure to have <span class="wrap-text"><span class="highlight-bg">Net banking credentials or Debit card</span></span> with you.</div>
      <button class="btn-primary" (click)="openEmandate()">Continue</button>
    </div>
    <!-- For Aadhar Mandate -->
    <div *ngIf="mandateVariants.esign" class="nach-right">
      <div class="nach-title">We are initiating your <span class="wrap-text">Aadhaar mandate registration</span></div>
      <div class="nach-info">Kindly make sure your <span class="wrap-text"><span class="highlight-bg">Aadhaar is linked with your </span></span><span class="highlight-bg"> bank account.</span></div>
      <button class="btn-primary" (click)="openEmandate()">Continue</button>
    </div>
    <!-- For P-NACH Mandate -->
    <div *ngIf="mandateVariants.isPhysicalNach" class="nach-right">
      <div class="nach-title">We are initiating your <span class="wrap-text">p-NACH mandate registration</span></div>
      <div class="nach-info">Kindly make sure you <span class="wrap-text"><span class="highlight-bg">upload the duly signed</span></span><span class="highlight-bg"> document.</span></div>
      <button class="btn-primary" (click)="openEmandate()">Continue</button>
    </div>
  </div>
</p-dialog>
